<template>
    <transition name="fade">
        <v-progress-circular  v-show="show" indeterminate size="30" class="progress"></v-progress-circular>
    </transition>
</template>

<script>
export default {
  name: 'MapUpdating',
  data () {
    return {
      show: false
    }
  },
  beforeMount () {
    setTimeout(() => this.show = true, 1000)
  }
}
</script>

<style scoped>
    .progress {
        position: absolute;
        top: 50%;
        right: 50%;
    }
</style>
